import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AppProviders } from './components/providers/AppProviders';
import { registerSW } from 'virtual:pwa-register';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './index.css';
import './i18n';

// Enregistrer le service worker
const updateSW = registerSW({
  onNeedRefresh() {
    // Avec registerType: 'autoUpdate', ceci sera rarement appelé
    // mais on applique quand même la mise à jour automatiquement
    console.log('Nouvelle version détectée, mise à jour automatique...');
    updateSW(true);
  },
  onOfflineReady() {
    console.log('L\'application est prête à fonctionner hors ligne');
  },
  onRegistered(registration) {
    console.log('Service Worker enregistré avec succès:', registration);

    // Vérifier les mises à jour toutes les 10 minutes
    if (registration) {
      setInterval(() => {
        console.log('Vérification de mise à jour du service worker...');
        registration.update();
      }, 10 * 60 * 1000); // 10 minutes
    }
  },
  onRegisterError(error) {
    console.error('Erreur lors de l\'enregistrement du Service Worker:', error);
  }
});

// Vérifier si le navigateur supporte les notifications
if ('Notification' in window) {
  console.log('Les notifications sont supportées');
  
  // Vérifier la permission actuelle
  if (Notification.permission === 'granted') {
    console.log('Permission des notifications déjà accordée');
  } else if (Notification.permission !== 'denied') {
    console.log('Demande de permission pour les notifications...');
    Notification.requestPermission().then(permission => {
      console.log('Permission des notifications:', permission);
    });
  }
} else {
  console.log('Les notifications ne sont pas supportées');
}

const root = document.getElementById('root');
if (!root) {
  console.error('Root element not found');
} else {
  console.log('Initializing app...');
  try {
    ReactDOM.createRoot(root).render(
      <React.StrictMode>
        <AppProviders>
          <App />
        </AppProviders>
      </React.StrictMode>
    );
    console.log('App initialized successfully');
  } catch (error) {
    console.error('Error initializing app:', error);
  }
}
